import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      enums: {
        QUERY_REQUEST_TASK: 'Query request task',
        // 'CUSTOM_LOAD_TASK': 'Custom load task',
        MRK_INFO_UPDATE_TASK: 'Mrk info update task',
        GOODS_LOAD_TASK: 'Goods load task',
        DOCUMENT_LOAD_TASK: 'Document load task',
        CLOSE_READY_ORDER_TASK: 'Close ready order task',
        GET_MRK_FROM_ACTIVE_ORDER_TASK: 'Get mrk from active order task',
        CHECK_MRK_STATUS_FROM_ORDER_TASK: 'Check mrk status from order task',
        CHECK_ORDER_STATUS_TASK: 'Check order status task',
        SEND_ACTIVE_ORDER_TASK: 'Send active order task',
        FTP_CHANGE_STATUS_TASK: 'Ftp change status task',
        FTP_LOAD_EAN_INFO_TASK: 'Ftp load ean info task',
        FTP_INVOICE_SUPPLIER_TASK: 'Ftp invoice supplier task',
        DOCUMENT_CHECKER_TASK: 'Document checker task',
        CUSTOM_KM_LOAD_TASK: 'Custom KM load task',
        CREATE_AND_SEND_INPUT_BY_MRK_TASK: 'Create and send input by MRK task',
        SOA_SUITE_MRK_SEND_BY_INVOICE_TASK: 'SOA Suite Mrk Send By Invoice Task',
        SEND_AGGR_BY_DOC_ERP_TASK: 'Send aggr by doc ERP Task',
        CREATE_AND_SEND_DOCUMENT_BY_DOC_ERP_TASK: 'Create and send document by doc ERP task',
        CREATE_ORDER_BY_UPDATED_QUANTITY_KM_TASK: 'Create order by updated quantity km task',
        CREATE_ORDER_BY_ARTICLE_MAP_KM_TASK: 'Create order by updated quantity km task',
        FTP_UDP_LOADER_TASK: 'Ftp udp loader task',
        MRK_INFO_UPDATE_V4_TASK: 'Mrk info update v4 task',
        SEND_NEW_OUT_TASK: 'Send new out task',
        MRK_STAT_UPDATE_TASK: 'Mrk stat update task',
        FTP_TORG_CHECK_DOCUMENT_TASK: 'Ftp Torg Check Document Task',
        FTP_XLS_TASK: 'FTP XLS Task',
        CUSTOM_NEW_STATUS_FIELD_CLEANER_TASK: 'KM fields cleaner task',
        FTP_UDP_LOADER_UPDATER_TASK: 'FTP UDP Loader Updater Task',
        SEND_NEW_INPUT_TASK: 'Send New Input Task',
        INPUT_NOTIFICATOR_TASK: 'Input Notificator Task',
        SEND_NEW_SHIPMENT_TASK: 'Send New Shipment Task',
        CHANGE_COMPANY_TASK: 'Change Company Task',
        FTP_UCD_LOADER_UPDATER_TASK: 'Ftp Ucd Loader Updater Task',
        RECONCILIATION_REPORT_TASK: 'Reconciliation Report Task',
        CRYPTO_TAIL_TASK: 'Crypto Tail Task',
        FTP_MARS_REPORT_LOADER_TASK: 'Ftp Mars Report Loader Task',
        KM_REQUEST_ADN_SAVE_TASK: 'Km Request Adn Save Task',
        WAREHOUSE_INFORM_TASK: 'Warehouse Inform Task',
        MRK_STATUS_CHANGE_HANDLING_TASK: 'Mass update of MRK statuses',
        FTP_INVOICE_SUPPLIER_V2_TASK: 'Ftp invoice supplier task - v2',
        REMARK_DOCUMENT_CREATING_TASK: 'Remark documents creating task',
        ATK_CREATION_TASK: 'ATK documents creating task',
        NOT_ENTERED_INTO_IMPORT_MRK_REPORT_TASK: ' Report on not entered imported KM',
        FORMAT_AND_PRINT_DATAMATRIX_IN_BASE64_TASK:
          'Formation and printing of Data Matrix labels in base64 format',
        SEND_NK_REQUEST_TASK: 'Nat. catalog sending requests',
        NK_REQUEST_ERROR_FIELD_TASK:
          'N. catalog collection of data on rejected applications (editing of unchangeable fields)',
        CONTROL_ORDERED_AND_TRANSFERRED_MC_REPORT_TASK:
          'CONTROL_ORDERED_AND_TRANSFERRED_MC_REPORT_TASK',
        ORDERED_MC_REPORT_TASK: 'ORDERED_MC_REPORT_SCHEDULER_TASK',
        FORMATION_OF_TRANSFER_DOCUMENT_TASK: 'FORMATION_OF_TRANSFER_DOCUMENT_TASK',
        OUT_NOTIFICATION_TASK: 'OUT_NOTIFICATION_TASK',
        CREATE_AND_SEND_DISAGGREGATION_TASK: 'Create and Send disaggregation',
        SEND_SETS_AGGREGATION_TASK: 'Send sets aggregation',
        PRODUCT_CHECKER_TASK: 'Product checker task',
        FEED_CHECKER_TASK: 'Feed checker task',
        CHECK_AND_SEND_NEW_ORDERS_TASK: 'Check and send new orders task',
        NK_MODERATION_AND_SIGN_TASK: 'Moderation and sign nk task',
        NK_GOODS_LOAD_TASK: 'Goods load nk task',
        IRREDUCIBLE_STOCK_TASK: 'Irreducible stock task',
        NK_NOT_PUBLISHED_TASK: 'Unpublished Cards Notification',
        NK_NOT_PUBLISHED_BY_ORDER_TASK: 'Notice for orders with unpublished cards',
      },
    },
  },
};
